module.exports = __webpack_public_path__ + "eb3b3234c5f0a05932a1af018c3b8ae8.jpg";